import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AppLinkService } from '../../core/services/app-link.service';

type RedirectItemKind = 'profile' | 'recipe' | 'auth';

@Component({
  selector: 'app-app-redirect-page',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './app-redirect-page.component.html',
  styleUrl: './app-redirect-page.component.scss',
})
export class AppRedirectPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly appLinks = inject(AppLinkService);

  readonly playStoreUrl = this.appLinks.playStoreUrl;
  readonly isAndroidDevice = this.appLinks.isAndroidDevice();

  invalidLink = false;
  appLinkUrl = '';
  title = 'Ouverture dans l’application';
  description =
    'Le site public est en maintenance. Ouvrez ce contenu directement dans l’application Android AfriFood.';

  ngOnInit(): void {
    const itemKind = (this.route.snapshot.data['itemKind'] as RedirectItemKind | undefined) ?? 'recipe';

    if (itemKind === 'auth') {
      const source = this.route.snapshot.queryParamMap.get('source') === 'email-verification'
        ? 'email-verification'
        : 'password-reset';
      this.title = 'Connexion dans l’application';
      this.description =
        'Ouvrez l’application Android AfriFood pour reprendre la connexion après cette action.';
      this.appLinkUrl = this.appLinks.buildAuthAppLink(source);
      return;
    }

    const itemId = Number(this.route.snapshot.paramMap.get('id'));

    if (!Number.isFinite(itemId) || itemId <= 0) {
      this.invalidLink = true;
      this.title = 'Lien indisponible';
      this.description =
        'Ce lien est incomplet. Le site public reste en maintenance pendant cette période.';
      return;
    }

    if (itemKind === 'profile') {
      this.title = 'Ce profil s’ouvre dans l’application';
      this.description =
        'Le site public est en maintenance. Utilisez l’application Android AfriFood pour consulter ce profil.';
      this.appLinkUrl = this.appLinks.buildProfileAppLink(itemId);
    } else {
      this.title = 'Cette recette s’ouvre dans l’application';
      this.description =
        'Le site public est en maintenance. Utilisez l’application Android AfriFood pour consulter cette recette.';
      this.appLinkUrl = this.appLinks.buildRecipeAppLink(itemId);
    }
  }
}
